var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#43464D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 21.6664V14.3331C26.2497 14.0116 26.1648 13.6958 26.0039 13.4175C25.843 13.1391 25.6118 12.908 25.3333 12.7472L18.9167 9.08058C18.638 8.91967 18.3218 8.83496 18 8.83496C17.6782 8.83496 17.362 8.91967 17.0833 9.08058L10.6667 12.7472C10.3882 12.908 10.157 13.1391 9.99609 13.4175C9.8352 13.6958 9.75033 14.0116 9.75 14.3331V21.6664C9.75033 21.9879 9.8352 22.3037 9.99609 22.582C10.157 22.8604 10.3882 23.0915 10.6667 23.2522L17.0833 26.9189C17.362 27.0798 17.6782 27.1645 18 27.1645C18.3218 27.1645 18.638 27.0798 18.9167 26.9189L25.3333 23.2522C25.6118 23.0915 25.843 22.8604 26.0039 22.582C26.1648 22.3037 26.2497 21.9879 26.25 21.6664Z",
    stroke: "#F7F7F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99756 13.3799L18.0001 18.009L26.0026 13.3799",
    stroke: "#F7F7F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.24V18",
    stroke: "#F7F7F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefIcon);
export default __webpack_public_path__ + "static/media/def_icon.4d8682a13e9b40239dacd272d6eac6a4.svg";
export { ForwardRef as ReactComponent };